// Fallback default for the published legal-document version. The AUTHORITATIVE
// current version now lives at runtime in the app_config table (key
// 'legal_version'), which record-acceptance stamps and the acceptance gate reads —
// so a materially revised document is published by bumping that row in the SQL
// Editor, with no redeploy. Keep this constant roughly in sync as a fallback for
// the signup call, but the DB value is what actually triggers re-acknowledgment.
export const CURRENT_LEGAL_VERSION = '2026-10-21';

export const LEGAL_URLS = {
  terms: 'https://trueloadapp.com/terms/',
  privacy: 'https://trueloadapp.com/privacy/',
} as const;
